<template>
  <v-card>
    <v-card-title>
      <div class="flex-container-space-between">
        <slot name="title"></slot>

        <div class="vertical-center-container text-xs-right">
          <slot name="options"></slot>
        </div>
      </div>
    </v-card-title>
    <v-container fluid>
      <v-layout row wrap>
        <slot name="content"></slot>
      </v-layout>
    </v-container>
    <div class="mx-3 mb-5">
      <slot name="actions"></slot>
      <card-divider-full></card-divider-full>
    </div>
    <v-card-actions></v-card-actions>
    <slot name="actionButton"></slot>
  </v-card>
</template>

<script>
export default {};
</script>

<style>
</style>